import React from 'react'
import { MenuItem, SubMenu } from 'react-pro-sidebar';
//import { NavLink  } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { RiTeamFill } from "react-icons/ri";
import { FaThList } from "react-icons/fa";
const CoManager = ({ isCollapsed }) => {
    const location = useLocation();
    
    const handleAllTeamsClick = (e) => {
        // If already on allteams page, force reload
     /*   if (location.pathname === '/dashboard/allteams') {
            //console.log('🔄 Already on allteams, forcing reload');
            window.location.reload();
            e.preventDefault();
        }*/ 
    };

    return (
        <>
            <SubMenu label={!isCollapsed && "Team Management " }icon={<RiTeamFill className='menu-icon' />} className='submenu-item'>
                <NavLink to="/dashboard/allteams" className='menu-item-link text-white' onClick={handleAllTeamsClick}>
                    <MenuItem>{isCollapsed ? <FaThList className='menu-icon' /> : 'All Teams'}</MenuItem>
                </NavLink>



            </SubMenu>
            {/* <SubMenu label="Payment " icon={<MdOutlinePayment className='menu-icon' />} className='submenu-item'>

                <NavLink to="/dashboard/payment" className='menu-item-link text-white'>
                    <MenuItem>{!isCollapsed && 'Payment History'}</MenuItem>
                </NavLink>


            </SubMenu> */}
        </>

    )
}

export default CoManager;